module.exports = __webpack_public_path__ + "img/four4Blue.b4ca0dbd.png";